"use client"
import { useState, useCallback } from "react"
import { Outlet } from "react-router-dom"
import { Box, Drawer, useMediaQuery, useTheme, Snackbar, Alert } from "@mui/material"
import SidebarContent from "./Sidebar"
import Header from "./Header"
import Footer from "./Footer"

const drawerWidth = 260
const drawerWidthCollapsed = 64
const drawerWidthMobile = 280

const AdminLayout = ({ onLogout }) => {
  const [sidebarOpen, setSidebarOpen] = useState(true)
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down("md"))
  const [snackbarOpen, setSnackbarOpen] = useState(false)
  const [snackbarMessage, setSnackbarMessage] = useState("")
  const [snackbarSeverity, setSnackbarSeverity] = useState("success")

  const showSnackbar = useCallback((message, severity = "success") => {
    setSnackbarMessage(message)
    setSnackbarSeverity(severity)
    setSnackbarOpen(true)
  }, [])

  const handleSnackbarClose = (event, reason) => {
    if (reason === "clickaway") {
      return
    }
    setSnackbarOpen(false)
  }

  return (
    <Box sx={{ display: "flex", height: "100vh" }}>
      {/* Sidebar Drawer */}
      <Drawer
        variant={isMobile ? "temporary" : "permanent"}
        open={isMobile ? sidebarOpen : true}
        onClose={() => setSidebarOpen(false)}
        sx={{
          width: isMobile ? drawerWidthMobile : sidebarOpen ? drawerWidth : drawerWidthCollapsed,
          flexShrink: 0,
          [`& .MuiDrawer-paper`]: {
            width: isMobile ? drawerWidthMobile : sidebarOpen ? drawerWidth : drawerWidthCollapsed,
            boxSizing: "border-box",
            transition: "width 0.3s",
            overflowX: "hidden",
            ...(isMobile && {
              position: "absolute",
              top: 0,
              left: 0,
              height: "100%",
              zIndex: theme.zIndex.drawer + 1,
            }),
          },
        }}
      >
        {/* Sidebar Content */}
        <SidebarContent open={sidebarOpen} isMobile={isMobile} setSidebarOpen={setSidebarOpen} />
      </Drawer>
      {/* Mobile Overlay */}
      {isMobile && sidebarOpen && (
        <Box
          sx={{
            position: "fixed",
            inset: 0,
            backgroundColor: "rgba(0,0,0,0.15)",
            zIndex: theme.zIndex.drawer - 1,
            transition: "opacity 0.3s ease-in-out",
            opacity: sidebarOpen ? 1 : 0,
            pointerEvents: sidebarOpen ? "auto" : "none",
          }}
          onClick={() => setSidebarOpen(false)}
        />
      )}
      {/* Main Content Area */}
      <Box
        component="main"
        sx={{
          flexGrow: 1,
          display: "flex",
          flexDirection: "column",
          height: "100%",
          minWidth: 0,
          overflowX: "hidden",
        }}
      >
        {/* Header */}
        <Header sidebarOpen={sidebarOpen} setSidebarOpen={setSidebarOpen} onLogout={onLogout} isMobile={isMobile} />
        {/* Page Content */}
        <Box sx={{ flexGrow: 1, p: 3, backgroundColor: "#f5f5f5", overflowY: "auto", overflowX: "auto" }}>
          <Outlet context={{ showSnackbar }} />
        </Box>
        {/* Footer */}
        <Footer />
      </Box>
      {/* Global Snackbar for notifications */}
      <Snackbar
        open={snackbarOpen}
        autoHideDuration={5000} // <-- এখানে স্থায়িত্বকাল 5 সেকেন্ড (5000 মিলিসেকেন্ড) করা হয়েছে
        onClose={handleSnackbarClose}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
      >
        <Alert onClose={handleSnackbarClose} severity={snackbarSeverity} sx={{ width: "100%" }}>
          {snackbarMessage}
        </Alert>
      </Snackbar>
    </Box>
  )
}
export default AdminLayout
